import amplitudeExperimentService from '@/services/amplitude/amplitude-experiment.service'
import {
  EebPlacementVariant,
  ExperimentFlags,
} from '@/services/amplitude/experiment-flags'

/**
 * Returns true when the user is assigned to the EEB placement experiment's
 * variant B (`mainscreen`) — EEB booking is removed from onboarding and shown
 * as a mainscreen task.
 *
 * Fail-safe: if the Experiment SDK is not initialized or the user is not
 * assigned, `variant()` returns null and we treat the user as control (A).
 */
const isMainscreenVariant = (): boolean =>
  amplitudeExperimentService.variant(ExperimentFlags.EebPlacement) ===
  EebPlacementVariant.Mainscreen

export default { isMainscreenVariant }
